import React from 'react'

import heroimage from '../images/cfoherobg.webp';
import { Helmet } from 'react-helmet';
import Menu from '../component/Menu';
import ServicesHeader from '../component/ServicesHeader';
import FooterNew from '../component/FooterNew';
import Getintouch2 from '../component/Getintouch2';
import CardStack from '../component/CardStack';


// import cardimg0 from '../images/Real Estate card.webp';
import cardimg1 from '../images/case-study-client26.webp';
import cardimg2 from '../images/case-study-client21.webp';
import cardimg3 from '../images/case-study-client4.webp';
import cardimg4 from '../images/case-study-client20.webp';
import cardimg5 from '../images/case-study-client2.webp';
import cardimg6 from '../images/case-study-client12.webp';
import cardimg7 from '../images/case-study-client11.webp';
import cardimg8 from '../images/case-study-client28.webp';


const herocontent = {
  "l1": "Your Challenge",
  "l2": "Our Solution",
  "l3": "We work as extended teams of organizations across domains and industries to solve complex business challenges, optimize investment strategies and drive long-lasting business growth by leveraging domain expertise, analytical rigour, and AI-enabled workflows ",
  "img": heroimage,
};

const customclass = "solution-header";


const cardStackData = [
  {
    id: 1,
    title: "Real Estate",

    description:
      "Helping developers, investors, real estate funds, and asset managers make informed decisions across acquisitions, development, and portfolio management through market intelligence, advanced analytics, and AI-enabled decision support.",

    servicesTitle: "What do we help with",

    services: [
      "Highest and Best Use (HBU) studies",
      "Real Estate Valuation",
      "Strategic Management Office (SMO)",
      "Feasibility Studies",
      "Market and Industry Research",
      "Land Use Planning",
      "Portfolio Analysis and Monitoring",
    ],

    button: {
      text: "Talk To Our Experts Now",
      link: "#contact",
    },

    caseStudy: {
      image: cardimg1,
      label: "CASE STUDY",
      title:
        "Feasibility Study for a Hotel Development by a Real Estate Development Company",
      description:
        "A real estate development company focused on building large-scale and mixed-use projects.",
      link: "/knowledge/feasibility-study-for-a-hotel-development-by-a-real-estate-development-company",
    },
  },

  {
    id: 2,
    title: "Family Offices",

    description:
      "We understand that each family office is unique in its foundation, challenges, and goals.  Be it a single-family office (SFO), multi-family office (MFO) or virtual family office (VFO), we customize our solutions to meet the goals, requirements and preferences of our clients.",

    servicesTitle: "What do we help with",

    services: [
      "Portfolio Analysis and Monitoring",
      "Corporate and Business Strategy",
      "Investment Strategy",
      "Transaction Support",
      "Project Management Office (PMO)",
      "Strategic Management Office (SMO)",
    ],

    button: {
      text: "Talk To Our Experts Now",
      link: "#contact",
    },

    caseStudy: {
      image: cardimg2,
      label: "CASE STUDY",
      title: "Corporate Strategy for a Single-Family Office",
      description:
        "The client is a family office governing and managing a multi-asset class portfolio worth $15 billion.",
      link: "/knowledge/corporate-strategy-for-a-single-family-office",
    },
  },

  {
    id: 3,
    title: "Investment Banks & Advisors",

    description:
      "We operate as an extension of Investment Bankers and Advisors by providing research, modelling, valuation, and transaction support enhanced by AI-enabled workflows and analytical capabilities across both buy and sell side mandates.",

    servicesTitle: "What do we help with",

    services: [
      "Mergers and Acquisitions",
      "Capital Structure and Analysis",
      "Investment Hypothesis Testing",
      "Pitchdecks and PPM",
      "Exit Strategy Planning",
      "Investor Kits",
      "Financial Modelling and Valuation",
      "Trading and Transaction Comparables",
      "Market and Industry Research",
      "Term Sheet Evaluation",
      "Data Room Management",
      "Deal Execution",
    ],

    button: {
      text: "Talk To Our Experts Now",
      link: "#contact",
    },

    caseStudy: {
      image: cardimg3,
      label: "CASE STUDY",
      title: "Enabling a Real Estate Conglomerate to Secure $40 Million Funding to Develop a Logistics Park",
      description:
        "A leading real estate master developer specializing in high-end experiential mixed-use real estate and mega-infra projects.",
      link: "/knowledge/enabling-a-real-estate-conglomerate-to-secure-$40-billion-funding-to-develop-a-logistics-park",
    },
  },

  {
    id: 4,
    title: "Private Equity & Venture Capital",

    description:
      "We support PE/VC firms throughout the deal lifecycle, from opportunity identification and diligence to portfolio monitoring and exit planning, through a combination of sector expertise, advanced analytics, and AI-enhanced research.",

    servicesTitle: "What do we help with",

    services: [
      "Financial Modelling and Valuation",
      "Transaction Support (IMs, Models, Teasers)",
      "Industry Landscaping",
      "Due Diligence Support",
      "Portfolio Analysis and Monitoring",
      "Capital Raising Support",
    ],

    button: {
      text: "Talk To Our Experts Now",
      link: "#contact",
    },

    caseStudy: {
      image: cardimg4,
      label: "CASE STUDY",
      title: "Financial Due Diligence for a U.S.-Based Private Equity Firm",
      description:"The client is a U.S.based private equity firm specializing in small-ticket investments ranging from $10 to $20 million. They primarily invest in companies with strong growth potential and competitive market positioning.",
      link: "/knowledge/financial-due-diligence-for-a-u.s.based-private-equity-firm",
    },
  },

  {
    id: 5,
    title: "Hedge Funds",

    description:
      "From identifying optimal investment vehicles to managing risks, our consultants work in tandem with the in-house team to orchestrate effective strategies that are attuned to the highly dynamic investment landscape.",

    servicesTitle: "What do we help with",

    services: [
      "Market and Industry Research",
      "Portfolio Analysis and Monitoring",
      "Buy Side Thematic Notes",
      "Equity Research",
      "Financial Modelling and Valuation",
      "Alternative Investment Analysis",
    ],

    button: {
      text: "Talk To Our Experts Now",
      link: "#contact",
    },

    caseStudy: {
      image: cardimg5,
      label: "CASE STUDY",
      title: "Enabling a U.S.-Based Hedge Fund to Optimize its Investment Strategy",
      description:"A U.S.based Hedge Fund with over $2 billion in assets under management and a focus on generating Alpha over and above market returns through a combination of long and short investment strategies.",
      link: "/knowledge/enabling-a-u.s.based-hedge-fund-to-optimize-its-investment-strategy",
    },
  },

  {
    id: 6,
    title: "Sovereign Wealth & Endowment Funds",

    description:
      "We empower Sovereign Wealth and Endowment Funds optimise portfolio construction, governance, and strategic investment decision-making through data-driven insights and AI-assisted analytics.",

    servicesTitle: "What do we help with",

    services: [
      "Portfolio Analysis and Monitoring",
      "Business Plans",
      "Enterprise Project Management Office (EPMO)",
      "Investment Policy Development",
      "Board Presentations",
      "Manager Selection and Monitoring",
    ],

    button: {
      text: "Talk To Our Experts Now",
      link: "#contact",
    },

    caseStudy: {
      image: cardimg6,
      label: "CASE STUDY",
      title:
        "Investment Policy Statement for an Endowment Fund",
      description:"The client is an endowment fund established 15 years ago with the aim of preserving, enhancing, and transferring wealth to upcoming generations. The fund manages an AUM of $35 million invested in a diversified portfolio of traditional and alternative asset classes.",
      link: "/knowledge/investment-policy-statement-for-an-endowment-fund",
    },
  },

  {
    id: 7,
    title: "Asset Managers",

    description:
      "We support asset managers through research, portfolio analytics, reporting, and leveraging AI capabilities that improve visibility, efficiency, and investment decision-making.",

    servicesTitle: "What do we help with",

    services: [
      "Market and Industry Research",
      "Asset Valuation",
      "Fund Tracking and Modelling",
      "Portfolio Analysis and Monitoring",
      "Manager Screening",
      "Financial Modelling and Valuation",
    ],

    button: {
      text: "Talk To Our Experts Now",
      link: "#contact",
    },

    caseStudy: {
      image: cardimg7,
      label: "CASE STUDY",
      title: "Private Equity Valuation Model for an Investment Firm",
      description:"The client is an investment firm seeking to expand its investment portfolio across real estate and non-real estate asset classes, including both private and public equity markets.",
      link: "/knowledge/private-equity-valuation-model-for-an-investment-firm",
    },
  },

  {
    id: 8,
    title: "Corporates",

    description:
      "We fuel corporate growth with bespoke strategies, balancing risk mitigation and sustainable profitability in a fast-paced business environment through consulting expertise, advanced analytics, and AI-enabled business intelligence.",

    servicesTitle: "What do we help with",

    services: [
      "Business Plans",
      "Annual Operating Plans",
      "Performance Management",
      "Financial Planning and Analysis",
      "Board Presentations",
      "Strategy Development",
    ],

    button: {
      text: "Talk To Our Experts Now",
      link: "#contact",
    },

    caseStudy: {
      image: cardimg8,
      label: "CASE STUDY",
      title: "Comprehensive Business Plan and Go-To-Market Strategy for a FinTech Company",
      description:"A FinTech Company, that enables investors to invest in Institutional Grade Real Estate properties through a Crowdfunding Platform",
      link: "/knowledge/comprehensive-business-plan-and-a-go-to-market-strategy-for-a-fintech-company",
    },
  },
];


const OurSolution = ({setBlank}) => {
  return (
    <>
        
        <Helmet>
            <title>Who We Serve</title>
             <meta property="og:title" content="Who We Serve" />
             <meta name='og:description' content='Who We Serve' />
             <meta name='keywords' content='' />
        </Helmet>
        <Menu setBlank={setBlank} />
        <ServicesHeader herocontent={herocontent} customclass={customclass} />
        <CardStack cards={cardStackData} />
        <Getintouch2 />
        <FooterNew setBlank={setBlank} />
    
    </>
    
  )
}

export default OurSolution